<template>
    <div>
      <NewsVideoList
        ref="table">
      </NewsVideoList>
    </div>
</template>

<script>
import NewsVideoList from './NewsVideoList.vue'

export default {
  name: 'NewsVideoManagement',
  components: {
    NewsVideoList
  },
  created () {
    this.callback = () => { this.updateNewsVideoList() }
    this.$bus.$on('updateNewsVideoList', this.callback)
  },
  destroyed () {
    this.$bus.$off('updateNewsVideoList', this.callback)
  },
  data () {
    return {
    }
  },
  methods: {
    updateNewsVideoList () {
      this.$refs.table.getTableData()
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
